<template>
    <div class="company-Main">
        <p class="current">当前位置：<span>专家详情</span></p>
        <div class="company-info">
            <p class="companyName">{{ companyInfo.name }}  <span>{{ companyInfo.title }}</span></p>
            <p class="descri video-publisher">{{ companyInfo.description }}</p>
            <div class="expertImage">
                <img :src="companyInfo.firstFile.FileUrl" alt="" class="companyImg">
            </div>
            
            <div class="company-detail">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="详细介绍" name="1">
                        <div v-html="companyInfo.intro" class="introinfo"></div>
                    </el-collapse-item>
                    <el-collapse-item title="专家证书" name="2">
                        
                        <img :src="item.FileUrl" alt="" v-for="item in companyInfo.cert_file" :key="item.id">
                    </el-collapse-item>
                   
                </el-collapse>
            </div>
            <div class="flex-bottom">
                <el-button type="primary" @click="VSPay">我要咨询￥{{ companyInfo.price }}</el-button>
                <!-- <el-button type="primary" v-show="type == 0">我要咨询￥{{ companyInfo.price }}</el-button> -->
                <el-button type="primary" @click="VSPay" v-show="type == 1">免费咨询</el-button>
            </div>
        </div>
       
        <el-dialog
            width="20%"
            title="扫码支付"
            :visible.sync="dialogFormEdit"
            customClass="messageDialog"
            >
            <div slot="footer" class="dialog-footer">
            <!-- <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="edit">确 定</el-button> -->
                <div id="canvas" style="padding-bottom: 20px;">

                </div>
            </div>
        </el-dialog>  
        <!-- <div class="" >
            nihao meiyoushuju 
        </div> -->
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default({
    data(){
        return {
            companyInfo: {
                firstFile: {FileUrl: ""},
                description:'',
                intro:'',
                cert_file: []
            },
            activeNames: ['1','2'],
            companyproduct: [],
            IsNull: true,
            type: 0,
            ispass: 0,
            vsfrom: 'native',
            dialogFormEdit: false
        }
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        VSPay(){
            console.log(this.companyInfo);
            var user_id = this.companyInfo.user_id
            if(user_id == 0){
                this.$notify({
                    title: '提示',
                    message: '专家未绑定会员',
                    type: 'warning',
                })
                return false
            }
            
            
            var ispass=this.ispass
            var info = this.companyInfo
            if(ispass == 1){
                this.allUrlToX(chatUrl)
                this.$router.push({
                    path: '/session/chatitemExpert',
                    query: {
                        chat_type: 'chat_expert',
                        to_user_id: user_id
                    }
                })
                return false
            }
          
       
            var data = {
                expert_id: info.id,
                pay_type: this.vsfrom
            }
            this.$store.dispatch('expert/expertPay',data)
                .then(res => {
                    if(res.ok){
                        if(res.msg == 'paysuccess'){
                            this.$router.push({
                                path: '/session/chatitemExpert',
                                query: {
                                    chat_type: 'chat_expert',
                                    to_user_id: user_id,
                                    order_no: res.data
                                }
                            })
                        }else{
                            document.getElementById( 'canvas' ).innerHTML =  '' ;
                            this.dialogFormEdit = true
                            
                            var qrcode = new QRCode('canvas', {
                                text: res.data.code_url,
                                width: 150,
                                height: 150,
                                colorDark : '#000000',
                                colorLight : '#ffffff',
                                correctLevel : QRCode.CorrectLevel.H
                            });
                            
                            let  timer = setInterval(() => {
                                this.getPaystatus(res.data.order_no,timer)
                            }, 5000)
                        }
                    }else{
						if(res.data == 'notlogin'){
                            this.$router.push({
                                path: '/login',
                            })
                            this.$notify({
                                title: '提示',
                                message: '请选登录再咨询',
                                type: 'error',
                            })
						}else if(res.data != ''){
                            this.$router.push({
                                path: '/session/chatitemExpert',
                                query: {
                                    chat_type: 'chat_expert',
                                    to_user_id: user_id,
                                    order_no: res.data
                                }
                            })
						}else{
                            this.$notify({
                                title: '提示',
                                message: res.msg,
                                type: 'warning',
                            })
						}
					}
                })

        },
        getPaystatus(orderNo,timer){
            setTimeout(()=>{
                let data = {
                    order_no: orderNo
                }
                this.$store.dispatch('personal/getPaystatus',data)
                    .then(res =>{
                        if(res.data.ispay == 1){
                            clearInterval(timer)
                             this.$notify({
                                title: '提示',
                                message: '支付成功',
                                type: 'success'
                            })

                            this.$router.push({
                                path: '/session/chatitemExpert',
                                query: {
                                    chat_type: 'chat_expert',
                                    to_user_id: this.companyInfo.user_id,
                                    order_no: orderNo
                                }
                            })

                        }
                    })
                
                
            }, 0)
         }

    },
    mounted(){
        let data = {
            id: this.$route.query.id
        }

        this.type = this.$route.query.type

        console.log("第一步");
        this.$store.dispatch('menu/expertinfo',data)
            .then(res => {
                if(res.ok){
                   
                    if(res.data == ''){
                      
                    }else{
                        this.companyInfo = res.data
                    }
                }
            })
        
    }
})
</script>


<style scoped lang="scss">
@import url(../../css/info.css);
.flex-bottom .el-button--primary{
    width: 100% !important;
}
@import url(../../css/info540.css);
.expertImage{
    width: 100%;
    text-align: center;
    
    
}  
.companyImg{
    width: 375px;height: 525px;
    margin: 10px auto;
} 
@media screen and (max-width: 540px) {
    .company-Main{
        width: 96%;
        margin: 45px auto;
        background: #fff;
        padding: 10px 0px;
        padding-bottom: 70px;
        position: relative;
    }
   
    .companyImg{
        width: 100%;height: 450px;
    }
    
    .flex-bottom{
        position: absolute;
        bottom: 20px;
        left: 50px;
        width: 300px;height: 40px;
    }
    .companyName{
        margin-top: 20px;
    }
    
}   
::v-deep .el-dialog .el-dialog__header {
    line-height: 0px !important;
}
::v-deep #canvas img{
    margin: auto !important;
}

::v-deep .el-dialog__body{
    padding: 10px 0 !important;
}
</style>